(function () {
  const form = document.getElementById('cf-form')
  if (!form) return
  const root = document.querySelector('.cf')
  function syncTop () {
    const header = document.getElementById('shopify-section-header')
    const headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0
    if (root) { root.style.setProperty('--cf-top', (headerHeight > 0 ? headerHeight + 20 : 200) + 'px') }
  }
  syncTop()
  window.addEventListener('resize', syncTop)
  const isDesktop = function () {
    return window.matchMedia('(min-width:1024px)').matches
  }

  /*
     The panel is open in the HTML for anyone without JS, and on mobile it closes on
     load so it does not push the products a screen and a half down. But checking a box
     now reloads the page, and closing it always meant reopening it for every filter.
     Whether the shopper had it open is remembered for the tab: someone arriving from
     outside still sees the products first.
  */
  const shell = document.querySelector('.cf-mobile')
  const STORAGE_KEY = 'cf-panel-abierto'
  function rememberShell () {
    if (!shell || isDesktop()) return
    try {
      sessionStorage.setItem(STORAGE_KEY, shell.open ? '1' : '0')
    } catch (e) {}
  }
  function syncShell () {
    if (!shell || isDesktop()) return
    let stored = null
    try {
      stored = sessionStorage.getItem(STORAGE_KEY)
    } catch (e) {}
    shell.open = stored === '1'
  }
  if (shell) shell.addEventListener('toggle', rememberShell)
  syncShell()

  const sortSelect = form.querySelector('[data-cf-sort]')
  const hiddenSort = form.querySelector('input[type="hidden"][name="sort_by"]')
  if (sortSelect && hiddenSort) hiddenSort.parentNode.removeChild(hiddenSort)

  /*
     An empty field is submitted anyway, and the URL ended with filter.v.price.gte=&lte=
     hanging off every filter touched. Disabling it leaves it out of the submission.
     There is no submit button any more, so this always goes through submitNow; the
     listener stays in case the browser submits the form on its own.
  */
  function clean () {
    const emptyValues = form.querySelectorAll('input[type="number"]')
    for (let i = 0; i < emptyValues.length; i++) {
      if (emptyValues[i].value === '') emptyValues[i].disabled = true
    }
    const page = form.querySelector('input[name="page"]')
    if (page) page.remove()
  }
  form.addEventListener('submit', clean)

  /*
     There are two order controls: the grid band's for desktop and the one above the
     panel for mobile. Both are named sort_by, so whichever is not visible is disabled
     and does not travel in the submission.
  */
  function singleSort () {
    const desktop = isDesktop()
    document.querySelectorAll('[data-cf-sort]').forEach(function (sortEl) {
      const inBand = !!sortEl.closest('.cf-sortbar--band')
      sortEl.disabled = inBand ? !desktop : desktop
    })
  }
  /*
     The band's select belongs to the grid section, which renders after this one: when
     the script runs it does not exist yet. So the state is reviewed once the document
     is ready, and the change is heard by delegation.
  */
  singleSort()
  window.addEventListener('resize', singleSort)
  window.addEventListener('load', singleSort)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', singleSort)
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-cf-sort]')) submitNow()
  })

  function submitNow () {
    clean()
    form.submit()
  }
  /*
     One visible checkbox can stand for several spellings of the same tag. They are
     synced before submitting, not after.
  */
  function mirror (source) {
    const key = source.getAttribute('data-cf-group-key')
    if (!key) return
    const mirrors = form.querySelectorAll('input[data-cf-mirror]')
    for (let i = 0; i < mirrors.length; i++) {
      if (mirrors[i].getAttribute('data-cf-mirror') === key) mirrors[i].checked = source.checked
    }
  }
  /*
     On mobile this waited for a button and on desktop it submitted on check: the same
     checkbox did one thing or the other depending on width, and on a phone checking
     looked like it did nothing. It applies at once on both now, and the button was
     redundant.
  */
  form.addEventListener('change', function (e) {
    const target = e.target
    if (target.matches('input[type="checkbox"]')) {
      mirror(target)
      submitNow()
    }
  });

  (function () {
    const seg = location.pathname.split('/').filter(Boolean)
    if (seg[0] !== 'collections') return
    const tags = Array.prototype.slice.call(document.querySelectorAll('.cf-tag[data-tag]'))
    if (!tags.length) return

    const base = '/' + seg.slice(0, 2).join('/')
    const search = location.search || ''
    const active = (seg.length > 2 ? decodeURIComponent(seg[2]).split('+') : []).filter(Boolean)
    function path (list) {
      return list.length ? base + '/' + list.join('+') + search : base + search
    }

    const owner = {}
    tags.forEach(function (tag) {
      const own = tag.getAttribute('data-tag')
      const group = tag.closest('.cf-group')
      if (own && group) owner[own] = group
    })

    const activeTags = []
    tags.forEach(function (tag) {
      const own = tag.getAttribute('data-tag')
      const box = tag.querySelector('.box')
      const index = active.indexOf(own)
      if (index > -1) {
        const rest = active.slice()
        rest.splice(index, 1)
        tag.classList.add('is-on')
        tag.setAttribute('aria-current', 'true')
        tag.setAttribute('href', path(rest))
        if (box) {
          box.classList.add('is-on')
          box.textContent = '\u2713'
        }
        activeTags.push(tag)
      } else {
        const group = tag.closest('.cf-group')
        const rest = active.filter(function (other) {
          return owner[other] !== group
        })
        tag.setAttribute('href', path(rest.concat([own])))
      }
    })
    if (!activeTags.length) return

    /*
       Liquid already renders a chip per active tag and already counts them in the
       badge. Everything below was written for when it did not, and by adding on top
       it left two chips per filter and double the badge: with Arizona Diamondbacks
       and Women it showed four chips and a 4. If the server already rendered it,
       nothing is touched here.
    */
    const serverRendered = document.querySelectorAll('.cf-chips .cf-chip').length > 0

    const toggle = document.querySelector('.cf-mobile-toggle')
    let badge = toggle ? toggle.querySelector('.badge') : null
    if (!serverRendered) {
      if (badge) {
        badge.textContent = String((parseInt(badge.textContent, 10) || 0) + activeTags.length)
      } else if (toggle) {
        badge = document.createElement('span')
        badge.className = 'badge'
        badge.textContent = String(activeTags.length)
        toggle.appendChild(badge)
      }
    }

    const groups = []
    activeTags.forEach(function (tag) {
      const group = tag.closest('.cf-group')
      if (group && groups.indexOf(group) < 0) groups.push(group)
    })
    groups.forEach(function (group) {
      const label = group.querySelector('summary span')
      if (!label) return
      const count = String(group.querySelectorAll('.cf-tag.is-on').length)
      const cur = label.querySelector('.num')
      if (cur) {
        cur.textContent = count
        return
      }
      const countBadge = document.createElement('span')
      countBadge.className = 'num'
      countBadge.textContent = count
      label.appendChild(document.createTextNode(' '))
      label.appendChild(countBadge)
    })

    const head = document.querySelector('.cf-head')
    let chips = document.querySelector('.cf-chips')
    if (!chips && head) {
      chips = document.createElement('div')
      chips.className = 'cf-chips'
      const after = document.querySelector('.cf-count') || head
      after.parentNode.insertBefore(chips, after.nextSibling)
    }
    if (chips && !serverRendered) {
      activeTags.forEach(function (tag) {
        const chip = document.createElement('a')
        chip.className = 'cf-chip'
        chip.setAttribute('rel', 'nofollow')
        chip.setAttribute('href', tag.getAttribute('href'))
        const lbl = tag.querySelector('.lbl')
        chip.appendChild(document.createTextNode(lbl ? lbl.textContent.trim() : ''))
        const clearIcon = document.createElement('span')
        clearIcon.className = 'close-x'
        clearIcon.setAttribute('aria-hidden', 'true')
        clearIcon.innerHTML = '&times;'
        chip.appendChild(clearIcon)
        chips.appendChild(chip)
      })
    }
    if (head && !head.querySelector('.cf-clear')) {
      const sortBy = new URLSearchParams(search).get('sort_by')
      const chipLink = document.createElement('a')
      chipLink.className = 'cf-clear'
      chipLink.setAttribute('rel', 'nofollow')
      chipLink.setAttribute(
        'href',
        base + (sortBy ? '?sort_by=' + encodeURIComponent(sortBy) : '')
      )
      chipLink.textContent = 'Clear all'
      head.appendChild(chipLink)
    }
  })()

  form.querySelectorAll('[data-cf-find]').forEach(function (box) {
    const group = box.closest('[data-cf-group]')
    const none = group.querySelector('[data-cf-none]')
    const opts = Array.prototype.slice.call(group.querySelectorAll('.cf-opt'))
    box.addEventListener('input', function () {
      const query = box.value.trim().toLowerCase()
      let shown = 0
      opts.forEach(function (opt) {
        const hit =
          !query || opt.querySelector('.lbl').textContent.toLowerCase().indexOf(query) > -1
        opt.hidden = !hit
        if (hit) shown++
      })
      if (none) none.hidden = shown > 0
    })
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault()
    })
  })

  /*
     Price submitted on its own shortly after leaving a field. Someone who typed Min and
     moved on to Max lost the maximum: the URL kept gte without lte, and the chip read
     "$100 - $349.99". Worse, that reload reordered the panel under the cursor and the
     click heading for Max landed on another filter. Nothing is submitted now until the
     shopper asks for it. The button appears on entering a field and stays while
     anything is unapplied, so the filter never looks unresponsive. Enter does what the
     button does.
  */
  const priceInputs = form.querySelectorAll('input[type="number"]')
  const applyPrice = form.querySelector('[data-cf-price-apply]')

  if (priceInputs.length && applyPrice) {
    const applied = []
    priceInputs.forEach(function (input) {
      applied.push(input.value)
    })

    function pricePending () {
      for (let i = 0; i < priceInputs.length; i++) {
        if (priceInputs[i].value !== applied[i]) return true
      }
      return false
    }

    function showApply (shouldShow) {
      applyPrice.hidden = !shouldShow
    }

    /*
       focusin bubbles and click covers touch: delegating on the block avoids
       depending on focus reaching each field, which does not always happen on mobile.
    */
    const priceBlock = applyPrice.parentElement
    priceBlock.addEventListener('focusin', function (e) {
      if (e.target !== applyPrice) showApply(true)
    })
    priceBlock.addEventListener('click', function (e) {
      if (e.target !== applyPrice) showApply(true)
    })

    priceInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        showApply(true)
      })
      /*
         On leaving it only hides if nothing is pending: while there are changes the
         button stays, which is the signal that a step is missing.
      */
      input.addEventListener('blur', function () {
        setTimeout(function () {
          if (pricePending()) return
          let within = false
          priceInputs.forEach(function (priceInput) {
            if (priceInput === document.activeElement) within = true
          })
          if (!within && document.activeElement !== applyPrice) showApply(false)
        }, 0)
      })
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault()
          submitNow()
        }
      })
    })

    applyPrice.addEventListener('click', function () {
      submitNow()
    })
  }
})()
